const SECTIONS = [
  {
    h: "1. Acceptance of Terms",
    p: "By accessing or using the website, applications, services, or content of Wealth First Inc. ('WFI', 'we', 'us'), you agree to be bound by these Terms of Service. If you do not agree, do not use the services.",
  },
  {
    h: "2. Services Provided",
    p: "WFI provides editorial content (long-form interviews, articles, member directory), a Funding Portal (AI-powered credit and lender analysis), a Partnership intake, and related consulting services. Services are offered on a subscription, one-time, or invitation basis as described on the website.",
  },
  {
    h: "3. Eligibility & Accounts",
    p: "You must be at least 18 years of age and capable of entering into a binding contract. You agree to provide accurate registration information and to keep your credentials secure. You are responsible for all activity under your account.",
  },
  {
    h: "4. Subscription, Billing & Cancellation",
    p: "Recurring memberships (WealthFirst PRO, AutoPilot) renew automatically at the cadence selected (monthly or annual). You may cancel at any time from your account dashboard, with cancellation effective at the end of the current billing period. The seven-day AutoPilot trial is converted to a paid subscription unless cancelled before its end. The one-time AI Funding Report is non-refundable after delivery of the PDF.",
  },
  {
    h: "5. Editorial Content & Intellectual Property",
    p: "All editorial content, interviews, video, photography, and copy on WFI properties are © Wealth First Inc. and its respective rights-holders. Members may stream and view content for personal, non-commercial use only. Redistribution, public performance, syndication, or commercial reuse requires written permission from our editorial desk.",
  },
  {
    h: "6. User Submissions",
    p: "By submitting an inquiry, application, comment, or any other material to WFI (including via the Partners, Funding, Contact, or Affiliate intake forms), you grant WFI a perpetual, worldwide, royalty-free license to use, store, and process that submission for the purposes of operating and improving the services.",
  },
  {
    h: "7. AI-Generated Reports & Analysis",
    p: "Funding reports and credit analyses produced by our AI agents are informational only. They are not financial advice, legal advice, or guarantees of approval by any lender or financial institution. You remain solely responsible for your financial and business decisions. WFI does not extend credit, originate loans, or provide investment advice.",
  },
  {
    h: "8. Accredited Investors & Suitability",
    p: "Where applicable, deal-flow content and certain Platinum-tier offerings are intended only for accredited investors as defined by applicable securities law. WFI does not verify accreditation in the present version of the service; participants self-attest. No content on WFI properties constitutes an offer to sell or solicitation to buy any security.",
  },
  {
    h: "9. Prohibited Conduct",
    p: "You agree not to: (a) reverse-engineer, scrape, or harvest content; (b) impersonate any person or entity; (c) interfere with or disrupt the services; (d) use the services to violate any law, regulation, or third-party right; (e) upload viruses or malicious code; (f) use automated systems against the services without express permission.",
  },
  {
    h: "10. Termination",
    p: "We may suspend or terminate your account at any time for breach of these Terms, fraudulent activity, or to protect the integrity of the platform. Upon termination, your right to access the services ceases immediately.",
  },
  {
    h: "11. Disclaimers",
    p: "THE SERVICES ARE PROVIDED 'AS IS' AND 'AS AVAILABLE' WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.",
  },
  {
    h: "12. Limitation of Liability",
    p: "TO THE MAXIMUM EXTENT PERMITTED BY LAW, WFI AND ITS AFFILIATES SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS, DATA, OR REPUTATION ARISING FROM YOUR USE OF THE SERVICES.",
  },
  {
    h: "13. Governing Law",
    p: "These Terms are governed by the laws of the State of Delaware, United States, without regard to its conflict-of-law provisions. Disputes shall be resolved exclusively in the state or federal courts located in Delaware.",
  },
  {
    h: "14. Changes to These Terms",
    p: "We may revise these Terms from time to time. Material changes will be notified by email or via a prominent notice on the website. Continued use of the services after changes take effect constitutes acceptance.",
  },
  {
    h: "15. Contact",
    p: "Questions about these Terms? Write to the editorial desk via the Contact page. Wealth First Inc., support@wealthfirstinc.tv.",
  },
];

export default function Terms() {
  return (
    <div data-testid="terms-page" className="max-w-[900px] mx-auto px-6 lg:px-10 pt-32 pb-24">
      <div className="mb-12 reveal">
        <p className="eyebrow mb-4">Legal</p>
        <h1 className="font-display text-6xl md:text-7xl mb-4 leading-[0.95]">Terms of Service</h1>
        <p className="text-sm uppercase tracking-[0.18em]" style={{ color: "var(--ink-faint)" }}>
          Effective {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
        </p>
      </div>
      <hr className="hairline mb-10" />
      <div className="space-y-10">
        {SECTIONS.map((s) => (
          <section key={s.h}>
            <h2 className="font-display text-2xl mb-3">{s.h}</h2>
            <p className="text-base leading-[1.85]" style={{ color: "var(--ink-muted)" }}>{s.p}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
